var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavouriteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "url(#paint0_linear_1_1354)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M15.1359 2.98359C15.5216 2.32132 16.4784 2.32132 16.8641 2.98359L20.6274 9.44483C20.7687 9.68743 21.0055 9.85945 21.2799 9.91887L28.5878 11.5014C29.3369 11.6636 29.6326 12.5735 29.1219 13.145L24.1398 18.7208C23.9528 18.9301 23.8623 19.2085 23.8906 19.4878L24.6438 26.9271C24.721 27.6896 23.947 28.252 23.2457 27.9429L16.4032 24.9277C16.1463 24.8145 15.8537 24.8145 15.5968 24.9277L8.75433 27.9429C8.05299 28.252 7.27897 27.6896 7.35617 26.9271L8.10939 19.4878C8.13767 19.2085 8.04723 18.9301 7.86017 18.7208L2.8781 13.145C2.36745 12.5735 2.6631 11.6636 3.41215 11.5014L10.7201 9.91887C10.9945 9.85945 11.2313 9.68743 11.3726 9.44482L15.1359 2.98359Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.111 13.546H15.3142V15.8363H18.8034V17.5411H15.3142V21.1653H12.8906V11.8347H19.111V13.546Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1354",
    x1: 16,
    y1: 0.5,
    x2: 16,
    y2: 32.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02C9A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteIcon);
export default __webpack_public_path__ + "static/media/favourite-icon.77f954e3ac920f48aaf6c4578e882619.svg";
export { ForwardRef as ReactComponent };